/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Apartment_Detail_GuestsInputs */

const en_apartment_detail_guests = /** @type {(inputs: Apartment_Detail_GuestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sleeps ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Sleeps {count}" |
*
* @param {Apartment_Detail_GuestsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_detail_guests = /** @type {((inputs: Apartment_Detail_GuestsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Detail_GuestsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_detail_guests(inputs)
});